import "@/App.css";
import { BrowserRouter, Routes, Route, Outlet } from "react-router-dom";
import { Toaster } from "sonner";
import FullSite from "@/pages/FullSite";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";
import ContractPortal from "@/pages/ContractPortal";
import InvoicePortal from "@/pages/InvoicePortal";
import PaymentSuccess from "@/pages/PaymentSuccess";
import { AuthProvider, ProtectedRoute } from "@/context/AuthContext";

const AuthLayout = () => (
  <AuthProvider>
    <Outlet />
  </AuthProvider>
);

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<FullSite />} />
          <Route path="/c/:token" element={<ContractPortal />} />
          <Route path="/i/:token" element={<InvoicePortal />} />
          <Route path="/payment/success" element={<PaymentSuccess />} />
          <Route element={<AuthLayout />}>
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route path="/admin" element={<ProtectedRoute><AdminDashboard /></ProtectedRoute>} />
          </Route>
          <Route path="*" element={<FullSite />} />
        </Routes>
      </BrowserRouter>
      <Toaster theme="light" position="bottom-right" richColors />
    </div>
  );
}

export default App;
